const cultura_de_dados = {
	no_ar: [
		{
			titulo: 'Novos consensos e Inovação nos negócios ',
			descricao: `
                Tiago Mattos <small>(dois encontros)</small>
			`
		},
		{
			titulo: 'Quanto vale a sua informação?',
			descricao: `
				Camilla Jimene<br />\n
                Leticia Pozza
			`
		},
		{
			titulo: 'Economia de dados',
			descricao: `
                Ronaldo Lemos
			`
		},
		{
			titulo: 'Open banking',
			descricao: `
                Igor Freitas <br />\n
                Ricardo Taveira
			`
		},
		{
			titulo: 'Blockchain',
			descricao: `
                Rosine Kadamani
			`
		}
	],
	insiders: [
		{
			titulo: 'Futuro',
			descricao: `
                Beatrys Fernandes
			`
		},
		{
			titulo: 'Cultura digital',
			descricao: `
                Beatrys Fernandes <br />\n
                Felipe Cireno Teobaldo
			`
		},
		{
			titulo: 'Cultura de dados',
			descricao: `
                Leticia Pozza
			`
		},
		{
			titulo: 'Design Thinking',
			descricao: `
                Natália Lima <br />\n
                Otavio Falcão
			`
		},
		{
			titulo: 'Produtos analíticos',
			descricao: `
                Ricardo Cappra <small>(dois encontros)</small>
			`
		}
	],
};

export { cultura_de_dados };
